import { Action } from '@ngrx/store';
import {
  PubnubMessageEvent,
  PubnubPresenceEvent,
  PubnubStatusEvent,
} from 'src/app/shared/pubnub/pubnub-types';
export const STATUS_CHANGE = '[Pubnub] Status change';
export const PRESENCE_CHANGE = '[Pubnub] Presence change';
export const MESSAGE_RECEIVED = '[Pubnub] Message received';

export class StatusChange implements Action {
  public readonly type = STATUS_CHANGE;
  constructor(public readonly status: PubnubStatusEvent) {}
}

export class PresenceChange implements Action {
  public readonly type = PRESENCE_CHANGE;
  constructor(public readonly presence: PubnubPresenceEvent) {}
}

export class MessageReceived implements Action {
  public readonly type = MESSAGE_RECEIVED;
  constructor(public readonly message: PubnubMessageEvent, public readonly dateReceived: Date) {}

  public getMessageBody<T>() {
    return this.message.message.body as T;
  }
}

export type All = StatusChange | PresenceChange | MessageReceived;
